import { UserRole } from '../contexts/AuthContext';

/**
 * Check if a user has any of the specified roles
 * @param currentUser - The current user object
 * @param roles - Array of roles to check for
 * @returns boolean indicating if user has any of the specified roles
 */
export const hasRoles = (currentUser: { roles?: UserRole[] } | null | undefined, roles: UserRole[]): boolean => {
  if (!currentUser?.roles) return false;
  return roles.some(role => currentUser.roles!.includes(role));
};